(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JsonPointer", [], factory);
	else if(typeof exports === 'object')
		exports["JsonPointer"] = factory();
	else
		root["JsonPointer"] = factory();
})(self, function() {
return 